const types = {
  SET_UNSIGNED_TMP_FILES: "SET_UNSIGNED_TMP_FILES",
  ADD_UNSIGNED_TMP_FILE: "ADD_UNSIGNED_TMP_FILE",
  DELETE_UNSIGNED_TMP_FILE: "DELETE_UNSIGNED_TMP_FILE",
  SET_SIGNED_FILES: "SET_SIGNED_FILES",
  ADD_SIGNED_TMP_FILE: "ADD_SIGNED_TMP_FILE",
};

export default types;
